import * as React from "react";
const SvgFilterList = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", height: "1em", viewBox: "0 -960 960 960", width: "1em", fill: "#e3e3e3", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M400-240v-80h160v80H400ZM240-440v-80h480v80H240ZM120-640v-80h720v80H120Z" }));
export default SvgFilterList;
